angular
    .module('tradersyard')
    .factory('analytic-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        filter.set(filter.get());
                    },
                    is: function (name) {
                        return (
                            (tab !== undefined ? tab.split('.')[filter.level] : tab) === name &&
                            (filter.parent !== undefined && tab !== undefined
                                ? tab.split('.')[0] === filter.parent
                                : true)
                        );
                    },
                    get: function () {
                        hash = $flex.$hash.get();

                        return ['statistics', 'portfolio', 'history'].indexOf(hash.split('.')[filter.level]) !== -1
                            ? hash.split('.')[filter.level]
                            : 'statistics';
                    },
                    set: function (name) {
                        name = filter.parent === undefined ? name : [filter.parent, name].join('.');

                        tab = name;

                        if (filter.on.change) filter.on.change();

                        if (filter.catch === true) {
                            $flex.$touch.make(name.split('.')[filter.level]);
                            $flex.$hash.set(name);
                        }
                    },
                    tab: function () {
                        return tab !== undefined ? tab.split('.')[filter.level] : tab;
                    },
                    on: {
                        change: undefined,
                    },
                    catch: true,
                    level: 0,
                    parent: undefined,
                };

            return filter;
        },
    ])
    .controller('analytic-query-ctrl', [
        '$scope',
        'analytic-read-filter',
        '$flex.scroll',
        function ($scope, $filter, $scroll) {
            $scope.filter = $filter;

            $scope.filter.on.change = function () {
                $scroll.switch($scope.filter.tab());
                $scope.$broadcast('analytic-' + $scope.filter.tab() + '-init');
            };

            $scope.$on('analytic-query-update', $filter.init);

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
